import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { NotificationManager } from "react-notifications";
import getFilterServices from '../../../services/getFilterServices'

const AddEdit = ({ open, setOpen, dialogType, editValue, setEditValue, fetchData }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    journalName: Yup.string().required("Journal Name is required"),
  });

  const formik = useFormik({
    initialValues: {
      journalName: editValue?.journalName || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let response;
        if (dialogType === "add") {
          response = await getFilterServices.AddManualJournal({
            journalName: values.journalName,
            journalid : values.journalid

          });
        } else {
          response = await getFilterServices.UpdateManualJournal({
            journalName: values.journalName,
            journalid: editValue.journalid,
          });
        }

        console.log("response" , response)
        if (response?.success) {
        
          handleClose();
          fetchData();
        }
      } catch (error) {
        console.error("Error:", error);
        NotificationManager.error(
          `Error ${dialogType === "add" ? "adding" : "updating"} Journal`,
          "Error"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const handleClose = () => {
    formik.resetForm();
    setEditValue(null);
    setOpen(false);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '300px',
          '& .MuiDialogContent-root': {
            padding: '20px 24px',
          },
          '& .MuiDialogActions-root': {
            padding: '16px 24px',
          }
        }
      }}
    >
      <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 600 }}>
        {dialogType === "add" ? "Add Journal" : "Edit Journal"}
      </DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <TextField
            fullWidth
            label="Journal Name"
            name="journalName"
            value={formik.values.journalName}
            onChange={formik.handleChange}
            error={formik.touched.journalName && Boolean(formik.errors.journalName)}
            helperText={formik.touched.journalName && formik.errors.journalName}
            margin="normal"
            sx={{
              '& .MuiInputBase-root': {
                height: '48px',
              },
              '& .MuiInputLabel-root': {
                fontSize: '1rem',
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleClose}
            sx={{ 
              fontSize: '1rem',
              padding: '8px 16px'
            }}
          >
            Cancel
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            disabled={loading}
            sx={{ 
              fontSize: '1rem',
              padding: '8px 16px'
            }}
          >
            {dialogType === "add" ? "Add" : "Update"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddEdit; 